import axios, { AxiosRequestConfig } from "axios";
import { AppConfig } from "@/config";

const baseConfig: AxiosRequestConfig = {
  baseURL: AppConfig.apiBaseUrl || "http://localhost:8000",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
};

export const apiClient = axios.create(baseConfig);
